import React, { useEffect } from "react";
import { useSuccessMessageState } from "hooks/ui/useSuccessMessageState";
import { useRouter } from "next/router";

export function JustGaveGiftListener() {
  const { showSuccessMessage } = useSuccessMessageState();

  const {
    query: { justGaveGift }
  } = useRouter();

  useEffect(() => {
    if (justGaveGift) {
      showSuccessMessage("Congratulations, you just purchased a gift subscription!");
    }
  }, []);

  return <></>;
}
